import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  const [action, setAction] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/actions`)
      .then((res) => res.json())
      .then((info) => setAction(info));


  }, []);
  return (
    <>
      {action.slice(0, 1).map((item) => (
        <section className="cta-section modern-home-section" key={item._id}>
          <div className="bg-color" />
          <div className="auto-container">
            <div className="inner-container modern-cta-shell">
              <div className="pattern-layer">
                <div className="pattern-1" style={{ backgroundImage: 'url(assets/images/shape/shape-23.png)' }} />
                <div className="pattern-2 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-24.png)' }} />
                <div className="pattern-3 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-25.png)' }} />
                <div className="pattern-4 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-26.png)' }} />
              </div>
              <div className="inner-box modern-cta-box">
                <span className="modern-eyebrow">Ready to automate your customer journey?</span>
                <h2>{item.heading}</h2>
                <p>See how AuraWeb can help you capture more enquiries, reduce admin, and keep follow-up running 24/7.</p>
                <div className="btn-box modern-cta-actions">
                  <Link to="/contact-us" className="theme-btn btn-one mr_20">
                    Book a Free Demo
                  </Link>
                  <Link to="/pricing" className="theme-btn btn-two">
                    View Pricing
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default CallToAction;
